var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_1712",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_1712",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADOElEQVR4nO3cv05UQRQG8G+GJRYGjQlv4J/aEi2sbBUewMgLSEUCcQVyg+AGjDHBztj4AhZKbWJh0NLERoOPgEskWrDxjgWasNddd9h7Zs44+/3Ku3DOsN/e5e7emQGIiIiIiIiIiGhUGO0B/Mt8UUw2XGMODjcAcwnAac9f/Q7gE4zbtod2q9Vq7gUcZi3JBrC4sjYNmOcAztYste+smd0smi8lxiUtyQB+P/kvAFihkiXgZjZWl14J1ROTXADzRTHZKMd3Uf+VX9W2HXMxtbcjqVeYmIZrzEH+yQeAcz/H3Z0AdWtJLgA4czNUaQMEqz2shvYAejjf66B1Zqp1v/nep8BCsTZlSrPT46ELtUYWQHpnADDR66Dvkw8Am8XSuz4PnRlqRAGlGMBIYQDKGIAyBqCMAShjAMoYgDIGoIwBKEsxgINeBxeKtSnfAneXH1zp89C3oUYUUIrfBX0BcLl60JRmZ3Fl3atACdfvod3hhxVGemeAccHuXDkgubtiyQVgD+0WgP0Apdsd23kSoG4tyQXQajX3nDWzAErBsmVpze3HRfFVsKaI5AIAgKMb6G4GQFugXLu0Zvph0dwWqCVuTHsA/bx98/rztavXn5Vj+GGO7hFMADjl+esHAD464GnHdm49KpY/hBtpPcndlPexuLLe8zJnY/Xef/f3JPkWNEoYgDIGoIwBKGMAyhiAMgagTPy6ucac/lQFXWsgGoDgnP5Uia81EAsgwJz+VImuNRAJIOCc/lSJrTUQebUGnNOfKrG1BjJvFwHn9KdKaq2B1D3h2nP6TyLmt6Gh1xpI/cOsPac/VaHXGuR+xZI8BqCMAShjAMoYgDIGoIwBKGMAyk70yTH2/j259wNOEEDs/Xty7/eHVwCx9+/Jvd9xAwOIvX9P7v2qBiYee/+e3PtVDT7lYu/fk3u/Cp/7AbH378m9X3cfj/qx9+/JvV8XfhBTxgCUMQBlDEAZA1DGAJQxAGUMQBkDUOYTQOz9e3Lv18Xnu6DY+/fk3q/L4DMg9v49uferGBhA7P17cu/3V/9BPxB7/57c+1V5XQXF3r8n937Hee8XFHv/ntz7ERERERERERHR6PkFBVPmxqR7c+0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldNumber);
export default __webpack_public_path__ + "static/media/field-number.c10991c401cdf2b6965c21f46e06235d.svg";
export { ForwardRef as ReactComponent };